import React from 'react';
import Image from 'next/image';

import MeshGradient from 'react-scale/components/elements/webgl/mesh-gradient';
import { CTA, Section } from 'react-scale/components';

const Hero = () => (
  <div className="relative">
    <div className="absolute z-0 block inset-0 overflow-hidden max-w-[100vw]">
      <div className="absolute inset-0 w-full bg-gradient-to-b from-black" />
      <div className="absolute inset-0 w-full bg-gradient-to-b from-black" />
      <MeshGradient
        style={{
          '--gradient-color-1': '#D1AAD7',
          '--gradient-color-2': '#5933b2',
          '--gradient-color-3': '#6B80D2',
          '--gradient-color-4': '#7B8CE7'
        }}
      />
    </div>
    <Section paddingBottom={false} paddingTop={false}>
      <div className="relative pt-10 mx-auto text-center pb-28 sm:py-20 md:py-28 lg:py-36 max-w-max">
        <div className="flex mx-auto mb-6 max-w-max">
          <Image src="/static/images/icons/open-datasets.svg" width={96} height={96} priority />
        </div>
        <h1 className="text-4xl sm:text-5xl leading-10 md:text-[64px] md:leading-[78px] text-white font-aeonik mb-6 md:mb-8">
          Open Datasets
        </h1>
        <h2 className="text-white text-lg leading-8 mb-[42px] md:mb-8 max-w-[300px] sm:max-w-none">
          Index of Open Datasets for Computer Vision and Natural Language Processing
        </h2>
        <div className="mx-auto max-w-max">
          <CTA
            cta={{
              hubspotModal: {
                formId: 'cfa8ac7e-4222-4a49-ba1a-2d0728a8b002',
                label: 'Subscribe for Updates'
              }
            }}
          />
        </div>
      </div>
    </Section>
  </div>
);

export default Hero;
